/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FilterConfig } from 'components/SearchAndFilters/FilterTypes';
import SearchAndFilters from 'components/SearchAndFilters/index';
import { useSetAtom } from 'jotai';
import React, { Suspense } from 'react';
import { Row, Col } from 'reactstrap';

import { filterValuesAtom, useOnFilterChangeResetAtoms } from './state';

const Filters: React.FC<{ filtersConfig: FilterConfig }> = ({
  filtersConfig,
}) => {
  const setFilterValues = useSetAtom(filterValuesAtom);
  const resetOnFilterChangeAtoms = useOnFilterChangeResetAtoms();

  const handleFilterChange = () => {
    // some change in the config happened, lets reapply filters using spread operator
    setFilterValues({ ...filtersConfig.getActiveFilterValues() });
    resetOnFilterChangeAtoms();
  };

  return (
    <Suspense fallback={<></>}>
      <Row className="flex justify-content-end">
        <Col xs="12" md="10">
          <SearchAndFilters
            config={filtersConfig}
            onChange={handleFilterChange}
          />
        </Col>
      </Row>
    </Suspense>
  );
};

export default Filters;
